<!-- results-table.component.html -->
<h1 mat-dialog-title></h1>
<div mat-dialog-content fxLayout="column">

  <div fxLayout="column" fxFlex="100" class="print">
      <div fxLayout="row" class="p-20">

        <div fxFlex fxLayout="row">
            <div fxFlex="50"><strong>{{organizacion}}</strong></div>
            <div fxFlex="50" fxLayout="column">
                            <div fxFlex fxLayoutAlign="end start">
                <img class="logo-icon" src="assets/images/logos/logo_RIC_horizontal_transparente.png" height="67" width="200" >
              </div>
              <div fxFlex fxLayoutAlign="end start" style="margin-right:20px">
                {{fecha | date:'dd/MM/yyyy'}}
              </div>
        </div>
      </div>
  </div>

  <div class="content" fxFlex fxLayout="column">

    <h1>{{sentencia.nombre}}</h1> 
    
    <p>{{sentencia.descripcion}}</p>

    <div *ngIf="esMatrizMultidimendionalPorNombre" fxFlex fxLayout="column">

      
      <div fxFlex fxLayout="row" style="margin-bottom: 20px;">
        <div fxLayout="column" style="min-width:200px;">
          <div style="min-height:30px;">
            <strong>Funcion / Valor</strong>
          </div>
          <div *ngFor="let opcion of matrizMultidimendionalPorNombre | keys" style="min-height:30px;">
            <strong>{{ (opcion.key.length>25)? (opcion.key | slice:0:25)+'...':(opcion.key) }}</strong>
          </div>
        </div>
        
        
        <div  *ngFor="let opcion of matrizPromedioKeys" style="min-width:200px; max-width:300px; margin-left:15px;">  
          <div style="min-height:30px;">
            <strong>{{(opcion.length>25)? (opcion | slice:0:25)+'...':(opcion) }}</strong>

          </div>
          <div *ngFor="let entry of matrizMultidimendionalPorNombre | keys">
            <div style="min-height:30px;">
              {{entry.value.matrizPromedio[opcion] | number : '1.2-2'}}
            </div>
          </div>
          
        </div>
      </div>
    
      <div fxFlex fxLayout="row" class="m-50">
        <ngx-charts-bar-vertical-2d
        [view]="view"
        [results]="multiPorNombre"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        [legendTitle]="legendTitle"
        (select)="onSelect($event)"
        (activate)="onActivate($event)"
        (deactivate)="onDeactivate($event)">
        </ngx-charts-bar-vertical-2d>
      </div>
    </div>

    <div *ngIf="matrizMultidimensionalKeys.length>0 && !esMatrizMultidimendionalPorNombre" fxFlex fxLayout="column">

      <div fxFlex fxLayout="row" style="margin-bottom: 20px;">
        <div fxLayout="column" style="min-width:200px;">
          
          <div *ngFor="let opcion of matrizValores" style="min-height:30px;">
            <strong>{{(opcion.length>25)? (opcion | slice:0:25)+'...':(opcion)}}</strong>
          </div>
        </div>

        <div *ngFor="let entry of matrizMultidimensional | keys" style="min-width:200px;max-width:300px;margin-left: 15px;">           
          <div >
            <div style="min-height:30px;"><strong>{{(entry.key.length>25)? (entry.key | slice:0:25)+'...':(entry.key)}}</strong></div>
            
            <div *ngFor="let entry2 of entry.value | keys" style="min-height:30px;">
            {{entry2.value | number : '1.2-2'}}
            </div>
          </div>
          
        </div>
      </div>
      
      <ngx-charts-bar-vertical-2d
      [view]="view"
      [results]="multi"
      [gradient]="gradient"
      [xAxis]="showXAxis"
      [yAxis]="showYAxis"
      [legend]="showLegend"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [xAxisLabel]="xAxisLabel"
      [yAxisLabel]="yAxisLabel"
      [legendTitle]="legendTitle"
      (select)="onSelect($event)"
      (activate)="onActivate($event)"
      (deactivate)="onDeactivate($event)">
      </ngx-charts-bar-vertical-2d>

    </div>

    <div *ngIf="matrizPromedioKeys.length>0 && !esMatrizMultidimendionalPorNombre" fxFlex fxLayout="column">

      <div fxLayout="row">
        <div fxLayout="column" style="min-width:200px;max-width:300px;">
          <div *ngFor="let opcion of tablaDeDebidaDiligencia.opciones" style="min-height:30px;">
            <strong>{{(opcion.nombre.length>25)? (opcion.nombre | slice:0:25)+'...':(opcion.nombre)}}</strong>
          </div>
        </div>

        <div fxLayout="column">
          <div *ngFor="let entry of matrizPromedio | keys" style="min-width:200px;max-width:300px;margin-left: 15px;">           
            <div >
              <div style="min-height:30px;">{{entry.value | number : '1.2-2'}}</div>
            </div>
          </div>
        </div>
     </div>

      <ngx-charts-bar-vertical
        [view]="view"
        [results]="single"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)">
      </ngx-charts-bar-vertical>

    </div>

    <div *ngIf="tablaDeDebidaDiligencia.tipo === 'EVALUACION_SIMPLE' && !esMatrizMultidimendionalPorNombre" fxFlex fxLayout="column">

      <div fxLayout="row">
        <div fxLayout="column" style="min-width:200px;">
          <div *ngFor="let opcion of single" style="min-height:30px;" fxLayout="row">
            <div fxFlex="80"><strong>{{opcion.name}}</strong></div>
            <div fxFlex="20">{{opcion.value}}</div>
          </div>
        </div>
      </div>


      <ngx-charts-bar-vertical
        [view]="view"
        [results]="single"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)">
      </ngx-charts-bar-vertical>

    </div>

  </div>
  <!-- TABS fin -->

</div>
<div mat-dialog-actions>
  <button mat-button (click)="printPdf()" [disabled]="disabled">{{'Imprimir' | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
